import CryptoJS from "crypto-js";
import moment from "moment";
import constants, {
  downloadableFileTypes,
  HarbourMortgageStandardQuestionName,
  MaskedStandardQuestionName,
  QUOTE_DISABLED_FIELDS,
  SAME_DEED_GROUPS,
  SAME_DEED_RULES,
  UploadDocumentTypesArrayConstansts,
  UploadDocumentTypesMIMEMap,
} from "../../src/common/constants";
import { useSelector } from "react-redux";
import { orderLawyerInfoSelector } from "../features/auth/orderLawyerInformationSlice";
import { setWarningMessages } from "../features/unifiedQuestions/unifiedQuestionSlice";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import parse from "html-react-parser";
import { useEffect } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

export const GenerateRandomString = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const setValidationCss = (error) => {
  return {
    "--placeholder-color": error
      ? constants.TextBoxErrorMsgCss.placeholderColor
      : "",
    "--placeholder-fontweight": error
      ? constants.TextBoxErrorMsgCss.placeHolderFontWeight
      : "",
    "--placeholder-fontsize": error
      ? constants.TextBoxErrorMsgCss.placeHolderFontSize
      : "",
    border: error ? constants.TextBoxErrorMsgCss.borderCss : "",
    "--placeholder-opacity": error
      ? constants.TextBoxErrorMsgCss.placeHolderFontOpacity
      : "0.5",
  };
};

export const ValidateQuestionAnswers = (key, requiredFieldMsg, yup) => {
  var element = document.querySelector("[name*='" + key + "']");
  let result = yup.mixed(); //.required(requiredFieldMsg);

  // Helper to safely check/convert object-like values to strings
  const normalizeValue = (value) => {
    if (value && typeof value === "object") {
      try {
        return JSON.stringify(value); // fallback so yup.string() won't throw typeError
      } catch {
        return ""; // just in case JSON.stringify fails
      }
    }
    return value;
  };

  //radiobutton or textbox
  if (
    (element?.getAttribute("type") === "radio" ||
      element?.getAttribute("type") === "text" ||
      element?.getAttribute("type") === "email" ||
      element?.getAttribute("type") === "number") &&
    element?.className?.includes("Mandatory")
  ) {
    if (
      element?.getAttribute("type") === "text" &&
      element?.className?.includes("textarea")
    ) {
      result = yup
        .string()
        .transform((value) => normalizeValue(value))
        .default("")
        .required(requiredFieldMsg)
        .test("dynamicTextInvalidCharTest", (value, Context) => {
          const { path, createError } = Context;
          const message = checkIsInvalidCharacterOrWordPresent(value, true);
          if (value && message !== null) {
            return createError({ path, message });
          } else if (value === "") {
            return false;
          } else {
            return true;
          }
        });
    } else if (
      element?.className?.includes("custom__datepicker") &&
      element?.className?.includes("Mandatory")
    ) {
      result = yup.mixed().test("dateRequired", requiredFieldMsg, (value) => {
        if (value === null || value === undefined || value === "") return false;
        return true;
      });
      return result;
    } else if (
      element?.getAttribute("type") === "text" &&
      !element?.className?.includes("addressField")
    ) {
      result = yup
        .string()
        .nullable(false)
        .transform((value) => normalizeValue(value))
        .default("")
        .required(requiredFieldMsg)
        .test("dynamicTextInvalidCharTest", (value, Context) => {
          const { path, createError } = Context;
          const message = checkIsInvalidCharacterOrWordPresent(value);
          if (value && message !== null) {
            return createError({ path, message });
          } else if (value === "") {
            return false;
          } else {
            return true;
          }
        });
    } else if (element?.getAttribute("type") === "email") {
      result = yup
        .string()
        .transform((value) => normalizeValue(value))
        .default("")
        .required(requiredFieldMsg)
        .test("emailRegexTest", (value) => {
          if (
            value === "" ||
            (value && !value?.match(constants.EmailRegex.isEmailRegx))
          ) {
            return false;
          } else {
            return true;
          }
        });
    } else {
      result = yup.string().default("").required(requiredFieldMsg);
    }
  } else if (
    (element?.getAttribute("type") === "radio" ||
      element?.getAttribute("type") === "text" ||
      element?.getAttribute("type") === "email" ||
      element?.getAttribute("type") === "number") &&
    !element?.className?.includes("Mandatory")
  ) {
    if (
      element?.getAttribute("type") === "text" &&
      element?.className?.includes("textarea")
    ) {
      result = yup
        .string()
        .transform((value) => normalizeValue(value))
        .test("dynamicTextInvalidCharTest", (value, Context) => {
          const { path, createError } = Context;
          const message = checkIsInvalidCharacterOrWordPresent(value, true);
          if (value && message !== null) {
            return createError({ path, message });
          } else {
            return true;
          }
        });
    } else if (
      element?.getAttribute("type") === "text" &&
      !element?.className?.includes("addressField")
    ) {
      result = yup
        .string()
        .transform((value) => normalizeValue(value))
        .test("dynamicTextInvalidCharTest", (value, Context) => {
          const { path, createError } = Context;
          const message = checkIsInvalidCharacterOrWordPresent(value);
          if (value && message !== null) {
            return createError({ path, message });
          } else {
            return true;
          }
        });
    } else if (element?.getAttribute("type") === "email") {
      result = yup
        .string()
        .transform((value) => normalizeValue(value))
        .default("")
        .test("emailRegexTest", (value) => {
          if (value && !value?.match(constants.EmailRegex.isEmailRegx)) {
            return false;
          } else {
            return true;
          }
        });
    } else {
      result = yup.mixed();
    }
  }
  if (
    element?.getAttribute("type") === "hidden" &&
    element?.closest(".custom__dropdown-wrapper") !== undefined &&
    element
      ?.closest(".custom__dropdown-wrapper")
      ?.className?.includes("Mandatory") &&
    !element
      ?.closest(".custom__dropdown-wrapper")
      ?.className?.includes("MultiSelect")
  ) {
    result = yup
      .string()
      .default("")
      .notOneOf(["0", ""], requiredFieldMsg)
      .required();
  }
  //select datepickertest for abri QC
  if (
    element?.className?.includes("custom__datepicker") &&
    (element?.getAttribute("standardquestionname") ===
      "PurchaseClosingDateExpress" ||
      element?.getAttribute("standardquestionname") === "ClosingDate_Express" ||
      element?.getAttribute("standardquestionname") ===
      "OriginalTransferExpress" ||
      element?.getAttribute("standardquestionname") ===
      "OriginalTransferDate_EO_Express")
  ) {
    const userLogin = getUserDetails();
    const isInternalUser = userLogin?.internalUser;
    result = yup
      .string()
      .transform((value) => normalizeValue(value))
      .default("")
      .test("datepickertest", (value, context) => {
        {
          const { path, createError, parent } = context;
          if (!value) return true;

          const givenDate = moment(new Date(value));
          const today = moment().startOf("day");
          const daysDifference = Math.abs(givenDate.diff(today, "days"));

          if (
            !isInternalUser &&
            daysDifference >= 31 &&
            parent &&
            parent?.Province === "QC" &&
            ((parent?.thisTransIsPurchase === "Yes" &&
              parent?.ownersPolicyReq === "Yes") ||
              (parent?.thisTransIsPurchase === "No" &&
                parent?.existingOwnersPolicyReq === "Yes"))
          ) {
            return createError({
              path,
              message: "Date must be within 31 days",
            });
          }

          return true;
        }
      });
  }

  if (
    element?.getAttribute("type") === "hidden" &&
    element?.closest(".custom__dropdown-wrapper") !== undefined &&
    element
      ?.closest(".custom__dropdown-wrapper")
      ?.className?.includes("Mandatory") &&
    element
      ?.closest(".custom__dropdown-wrapper")
      ?.className?.includes("MultiSelect")
  ) {
    result = yup.mixed().test({
      message: requiredFieldMsg,
      test: (val) => {
        return (
          val instanceof Array &&
          val.filter((i) => i.value == "0").length === 0 &&
          val.length > 0
        );
      },
    });
  }

  if (
    (element?.getAttribute("type") === null ||
      element?.getAttribute("type") === "text") &&
    element?.className?.includes("addressField")
  ) {
    result = yup
      .string()
      .transform((value) => normalizeValue(value))
      .test("dynamicAddressFieldValidation", function (value) {
        const { path, createError } = this;
        let basePath = path.replaceAll("[", ".").replaceAll("]", "");

        const errors = {};
        const fieldsToCheck = [
          //"PropertyUnitNum",
          "PropertyCity",
          "Province",
          "PropertyPostalCode",
        ];

        fieldsToCheck.forEach((field) => {
          const fieldValue = document.querySelector(
            `[name="${basePath}.${field}"]`,
          )?.value;
          if (!fieldValue || (field === "Province" && fieldValue === "0")) {
            errors[field] = requiredFieldMsg;
          }
        });

        if (Object.keys(errors).length > 0) {
          return createError({
            path,
            message: JSON.stringify(errors),
          });
        } else {
          return true;
        }
      });
  }

  if (
    element?.getAttribute("type") === "uploadButton" &&
    element?.className?.includes("Mandatory")
  ) {
    result = yup
      .array()
      .test(
        "not-empty",
        "UploadDynamicFieldNonEmpty",
        (value) => Array.isArray(value) && value.length > 0,
      );
  }

  return result;
};

export const convertArrayToRawString = (arr) => {
  if (Array.isArray(arr) && arr?.length > 0) {
    return `[${arr
      .map(
        (o) =>
          `{${Object.entries(o)
            .map(([k, v]) => `${k}: ${typeof v === "string" ? `"${v}"` : v}`)
            .join(", ")}}`,
      )
      .join(", ")}]`;
  }
};

export const dynamicAddressValidation = (errorString) => {
  const jsonMatch = errorString?.match(/\{[\s\S]*\}/);
  let propertyData = {};

  if (jsonMatch) {
    try {
      propertyData = JSON.parse(jsonMatch[0]);
      Object.keys(propertyData).forEach((key) => {
        let value = propertyData[key];
        if (typeof value === "string") {
          value = value.replace(/^"(.*)"$/, "$1");
          value = value.replace(/\\"/g, '"');
        }
        propertyData[key] = value;
      });
    } catch (e) {
      console.error("Failed to parse JSON:", e);
    }
  }
  return propertyData;
};

export const convertRawStringToArray = (str) => {
  if (!str || typeof str !== "string") return [];

  // Remove starting/ending brackets
  const inner = str.trim().slice(1, -1);

  // Split objects by "},"
  const objectStrings = inner
    .split("},")
    .map(
      (s) => s.replace(/^\s*|\s*$/g, "") + (s.trim().endsWith("}") ? "" : "}"),
    );

  return objectStrings.map((objStr) => {
    // Remove surrounding braces
    const clean = objStr.replace(/^{|}$/g, "");

    const obj = {};
    clean.split(",").forEach((pair) => {
      const [rawKey, rawVal] = pair.split(":").map((s) => s.trim());

      const key = rawKey;

      // Remove quotes if present
      let value = rawVal;
      if (/^".*"$/.test(rawVal)) {
        value = rawVal.slice(1, -1); // remove quotes
      } else if (!isNaN(rawVal)) {
        value = Number(rawVal); // convert numeric strings
      }

      obj[key] = value;
    });

    return obj;
  });
};
export function formatTime(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var amOrPm = hours >= 12 ? "PM" : "AM";

  // Convert hours from 24-hour format to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // Handle midnight (0 hours)

  // Pad single digits with a leading zero if necessary
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  // Return the formatted time string
  return hours + ":" + minutes + ":" + seconds + " " + amOrPm;
}

// Example usage:
var currentTime = new Date();
var formattedTime = formatTime(currentTime);

export function formatDate(date) {
  // Get the month, day, and year from the Date object
  var month = date.getMonth() + 1; // Months are zero-based
  var day = date.getDate();
  var year = date.getFullYear();

  // Pad single digits with a leading zero if necessary
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }

  // Return the formatted date string
  return month + "/" + day + "/" + year;
}
export const formatDDMMYYYY = (date) => {
  const today = new Date(date);
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  return dd + "/" + mm + "/" + yyyy;
};
export const getUserDetails = () => {
  try {
    const decryptedBytes = CryptoJS.AES.decrypt(
      window.localStorage.getItem("userInfo"),
      process.env.REACT_APP_CRYPTO_KEY,
    );
    return JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
  } catch (err) {
    return null;
  }
};
export const getFileDetails = () => {
  try {
    const decryptedBytes = CryptoJS.AES.decrypt(
      window.sessionStorage.getItem("fileInfo"),
      process.env.REACT_APP_CRYPTO_KEY,
    );
    return JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
  } catch (err) {
    return null;
  }
};

export const getUniqueArray = (key = "id", array = []) => {
  return [
    ...new Map(array.filter(Boolean).map((item) => [item[key], item])).values(),
  ];
};

export const getSession = () => {
  if (localStorage.getItem("session")) {
    var byte = CryptoJS.AES.decrypt(
      localStorage.getItem("session"),
      process.env.REACT_APP_CRYPTO_KEY,
    );
    const decryptedBytes = JSON.parse(byte.toString(CryptoJS.enc.Utf8));
    return decryptedBytes ? decryptedBytes : false;
  } else {
    return false;
  }
};
export const setSession = () =>
  localStorage.setItem(
    "session",
    CryptoJS.AES.encrypt(
      JSON.stringify(moment()),
      process.env.REACT_APP_CRYPTO_KEY,
    ).toString(),
  );

export const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};
// const handleUpload = async (files) => {
//   for (let file of files) {
//     await uploadPdf(file);
//   }

//   console.log('All files uploaded!');
// };

// const uploadPdf = (file) => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = () => {
//       const pdfBase64 = reader.result;
//       fetch('/api/upload-pdf', {
//         /* ... */
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           console.log('PDF uploaded!', data);
//           resolve();
//         })
//         .catch((error) => {
//           reject(error);
//         });
//     };
//     reader.readAsDataURL(file);
//   });
// };
// const base64ToPDF = (base64) => {
//   const pdfBlob = new Blob(
//     [
//       atob(base64)
//         .split('')
//         .map((c) => c.charCodeAt(0)),
//     ],
//     { type: 'application/pdf' }
//   );

//   const pdfUrl = URL.createObjectURL(pdfBlob);

//   window.open(pdfUrl, '_blank');

//   return pdfUrl;
// };

const getFileExtension = (filename) => {
  return filename.split(".").pop().toLowerCase();
};

export const convertfromBase64 = (data, filename = "") => {
  //const base64WithoutPrefix = data.split('base64,')[1];
  const bytes = atob(data);
  let { length } = bytes;
  const out = new Uint8Array(length);
  /* eslint-disable-next-line no-plusplus */
  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  const fileExtension = getFileExtension(filename).toLowerCase();
  let mimeType = "application/pdf"; // default

  if (UploadDocumentTypesMIMEMap[fileExtension]) {
    mimeType = UploadDocumentTypesMIMEMap[fileExtension];
  }

  const blob = new Blob([out], { type: mimeType });
  const url = URL.createObjectURL(blob);

  if (downloadableFileTypes?.includes(fileExtension)) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url); // Clean up
  } else {
    window.open(url, "_blank");
  }
};

export const formatDocumentUploadBase64StringByDocumentType = (
  type,
  Base64String,
) => {
  switch (type) {
    case "application/pdf":
      Base64String = Base64String.replace("data:application/pdf;base64,", "");
      break;
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      Base64String = Base64String.replace(
        "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,",
        "",
      );
      break;
    case "application/msword": // .doc
      Base64String = Base64String.replace(
        "data:application/msword;base64,",
        "",
      );
      break;
    case "application/rtf": // .rtf
      Base64String = Base64String.replace("data:application/rtf;base64,", "");
      break;
    case "image/jpeg": // .jpeg, .jpg
      Base64String = Base64String.replace("data:image/jpeg;base64,", "");
      break;
    case "image/gif": // .gif
      Base64String = Base64String.replace("data:image/gif;base64,", "");
      break;
    case "image/bmp": // .bmp
      Base64String = Base64String.replace("data:image/bmp;base64,", "");
      break;
    // case "application/x-mfg": // .mfg (custom MIME type, may vary)
    //   Base64String = Base64String.replace("data:application/x-mfg;base64,", "");
    //   break;
    default:
      console.warn("Unsupported file type:", type);
      break;
  }
  return Base64String;
};

export const logUnAcceptedFiles = (files, { toast }, t) => {
  const rejectedFiles = files?.filter(
    ({ type }) => !UploadDocumentTypesArrayConstansts?.includes(type),
  );

  if (rejectedFiles?.length > 0) {
    rejectedFiles?.forEach((file) => {
      toast.error(t("DocumentUploadError") + ` (${file?.name})`);
    });
  }
};

export const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
export const fiveDigitPin = /^\d{5}$/;
export const fourDigitPin = /^\d{4}$/;
export const postalCodeRegex = /^[^\s]+(\s[^\s]+)?$/;
export const faxRegex = /^\d{3}-\d{3}-\d{4}$/;

export const showHideWithHandleChangeTab = (
  refer,
  value,
  { setHideID, setShowID },
) => {
  for (let i = 0; i < refer?.length; i++) {
    const handleSplitCondition =
      refer[i]?.visibleCondition?.split("<othercondition>");
    for (let j = 0; j < handleSplitCondition?.length; j++) {
      const handleSplitConditionComma = handleSplitCondition[j]?.split(",");
      for (let k = 0; k < handleSplitConditionComma?.length; k++) {
        const referVal = handleSplitConditionComma[k]
          ?.split("#")[1]
          ?.split("^")[0]
          ?.split(":")[1];
        if (value === referVal) {
          handleSplitCondition[j]?.includes("hide")
            ? setHideID(
              handleSplitConditionComma[k]
                ?.split(",")[0]
                ?.split("_")[1]
                ?.trim(),
            )
            : setShowID(
              handleSplitConditionComma[k]
                ?.split(",")[0]
                ?.split("_")[1]
                ?.trim(),
            );
        } else {
          !handleSplitCondition[j]?.includes("hide")
            ? setHideID(
              handleSplitConditionComma[k]
                ?.split(",")[0]
                ?.split("_")[1]
                ?.trim(),
            )
            : setShowID(
              handleSplitConditionComma[k]
                ?.split(",")[0]
                ?.split("_")[1]
                ?.trim(),
            );
        }
      }
    }
  }
};

export const checkIsInvalidCharacterOrWordPresent = (value, textarea) => {
  const invalidChars = "<>";
  const regex = new RegExp(`[${invalidChars}]`);
  if (
    value?.toLowerCase() === "n/a" ||
    value?.trim().toLowerCase() === "n/a" ||
    value?.toLowerCase() === "unknown" ||
    value?.toLowerCase() === "i don't know" ||
    value?.toLowerCase() === "i dont know" ||
    value?.toLowerCase() === "i do not know" ||
    value?.toLowerCase() === "i donot know"
  ) {
    return "InvalidWords";
  } else if (regex.test(value)) {
    return "InvalidCharacters";
  } else if (textarea && value?.length <= 8) {
    return "InvalidLength";
  } else {
    return null;
  }
};

export const GetWarningMessage = (
  condition,
  item,
  index,
  tab,
  questions,
  isLoanPolicy,
  warningType,
  { setWarningMessage, dispatch },
) => {
  const conditionsAnd = condition?.split("&&");
  if (
    questions?.length > 0 &&
    conditionsAnd?.length > 0 &&
    tab === 2 &&
    condition?.includes("closingDate")
  ) {
    let trueCount = 0;

    const closingDateID = questions
      ?.filter(
        (x) =>
          x.propertyIndex === index?.toString() || x.propertyIndex === index,
      )[0]
      ?.questions?.filter(
        (x) =>
          x.standardQuestionName === "PurchaseClosingDateExpress" ||
          x.standardQuestionName === "ClosingDate_Express" ||
          x.standardQuestionName === "OriginalTransferExpress" ||
          x.standardQuestionName === "OriginalTransferDate_EO_Express",
      )[0]?.id;

    const fieldName = `PropertyInfo.${index}.QuestionID_${closingDateID}`;

    // Wait until closing date is selected
    const closingDateValue = item?.[`QuestionID_${closingDateID}`];

    if (!closingDateValue) {
      setWarningMessage((old) => old.filter((w) => w.fieldName !== fieldName));

      dispatch(setWarningMessages(false));
      return;
    }

    conditionsAnd?.forEach((cn) => {
      const cnSplit = cn?.split("#");

      // Closing Date Condition
      if (cnSplit[0]?.includes("closingDate")) {
        const givenDate = moment(new Date(closingDateValue));

        const dayDifference = givenDate.diff(moment(), "days");

        if (
          cnSplit[1]?.includes("<") &&
          dayDifference < parseInt(cnSplit[1].substring(1, cnSplit[1].length))
        ) {
          trueCount++;
        } else if (
          cnSplit[1]?.includes(">") &&
          dayDifference > parseInt(cnSplit[1].substring(1, cnSplit[1].length))
        ) {
          trueCount++;
        }
      }

      // Province Condition
      if (
        cnSplit[0]?.includes("Prov") &&
        cnSplit[1]?.split(",")?.includes(item?.Province)
      ) {
        trueCount++;
      }

      // Transaction Type Condition
      if (cnSplit[0]?.includes("transType")) {
        if (
          (cnSplit[1]?.split(",")?.includes("Purchase") &&
            item?.thisTransIsPurchase === "Yes" &&
            item?.ownersPolicyReq === "Yes") ||
          (cnSplit[1]?.split(",")?.includes("ExistingOwner") &&
            item?.existingOwnersPolicyReq === "Yes")
        ) {
          trueCount++;
        }
      }
    });
    if (trueCount === conditionsAnd?.length) {
      setWarningMessage((old) => [
        { fieldName, type: warningType },
        ...old.filter((w) => w.fieldName !== fieldName),
      ]);

      dispatch(setWarningMessages(true));
    } else {
      setWarningMessage((old) => old.filter((w) => w.fieldName !== fieldName));

      dispatch(setWarningMessages(false));
    }
  }
};

export const groupQuestionsByRow = (questions) => {
  const grouped = questions
    ?.filter((item) => item.orderGroupRowNumber !== 0)
    ?.reduce((acc, item) => {
      const key = `${item.parentQuestionID}-${item.orderGroupRowNumber}-${item.parentQuestionValue}-${item.cticNewSection}`;

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(item);
      return acc;
    }, {});

  if (!grouped) return {};

  // Convert grouping keys → { parentQuestionID: [items], parentQuestionID: [items] }
  const mapped = {};

  Object.values(grouped).forEach((arr) => {
    const parentId = arr[0]?.parentQuestionID;
    if (!mapped[parentId]) mapped[parentId] = [];
    mapped[parentId].push(arr);
  });

  return Object.keys(mapped).map((key) => ({
    [key]: mapped[key],
  }));
};

export const groupMissingInfo = (fields, propCount) => {
  if (propCount > 1) {
    const groupedFields = fields?.reduce((acc, item) => {
      const key = `${item.propertyIndex}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});

    if (groupedFields) {
      const sortedKeys = Object.keys(groupedFields).sort((a, b) => {
        return Number(a) === -1
          ? -1
          : Number(b) === -1
            ? 1
            : Number(a) - Number(b);
      });

      return sortedKeys.map((key) => groupedFields[key]);
    }

    return [];
  } else {
    return fields ? [fields] : [];
  }
};

export const getFileNumberfromFileID = (fileID) => {
  var fileNumber = 0;
  if (fileID !== undefined && fileID !== 0) {
    fileNumber = fileID + 100000;
  }
  return fileNumber;
};

export const getFileIDfromFileNumber = (fileNumber) => {
  var fileID = 0;
  if (fileNumber !== undefined && fileNumber !== 0) {
    fileID = parseInt(fileNumber) - 100000;
  }
  return fileID;
};

export function IsDashBoardLawfirmSelected(DashboardLawfirm) {
  console.log(
    "🚀 ~ IsDashBoardLawfirmSelected ~ DashboardLawfirm:",
    DashboardLawfirm,
  );
  if (
    DashboardLawfirm !== null &&
    DashboardLawfirm !== undefined &&
    DashboardLawfirm?.FirmID !== "" &&
    Object.keys(DashboardLawfirm).length !== 0
  ) {
    return true;
  } else return false;
}

export function IsObjectNotEmpty(object) {
  if (object !== null && object !== undefined && object !== "") {
    return true;
  } else {
    return false;
  }
}

export const getLawfirmForInternalUser = (
  userFirm,
  DashboardLawfirm,
  isInternalUser,
  multipleFirmsUser,
) => {
  var FirmID = userFirm?.firmID;
  if (isInternalUser) {
    var dashboardfirmID = localStorage?.getItem("selectedFirmId");
    // if (
    //   DashboardLawfirm !== undefined &&
    //   DashboardLawfirm !== null &&
    //   DashboardLawfirm?.FirmID !== undefined &&
    //   DashboardLawfirm?.FirmID !== ""
    // ) {
    //   FirmID = DashboardLawfirm?.FirmID;
    // }
    if (
      dashboardfirmID !== undefined &&
      dashboardfirmID !== null &&
      dashboardfirmID > 0
    ) {
      FirmID = dashboardfirmID;
    }
  } else if (multipleFirmsUser) {
    FirmID = localStorage?.getItem("selectedFirmId");
  }

  return FirmID;
};

export const questionCheck = ({
  visibleCondition,
  tabOrderID,
  tabID,
  conditionChecker,
  // show,
  // setShow,
  ID,
  editOrderDetails,
  hideID,
  showID,
  valuesParent,
  valuesOverall,
  i,
  questions,
  item,
}) => {
  let show = false;
  if (
    visibleCondition &&
    tabOrderID === tabID &&
    !visibleCondition?.toLowerCase()?.includes("handlechangetab") &&
    !visibleCondition?.toLowerCase()?.includes("defaulthide") &&
    !visibleCondition?.toLowerCase()?.includes("defaultshow")
  ) {
    const totalConditions = visibleCondition?.split("<otherCondition>");
    const finalResult = conditionChecker(
      totalConditions,
      valuesParent,
      valuesOverall,
      i,
      questions,
      editOrderDetails,
      item,
    );
    if (finalResult && !show) {
      show = true;
    } else if (!finalResult && show) {
      show = false;
    }
    // else if (!finalResult && !show) {//need to verify//fix as part of duplicate questions present in form
    //   setValue(`${formName}.QuestionID_${id}`, undefined);
    // }
  } else {
    if (!show && !visibleCondition?.toLowerCase()?.includes("defaulthide")) {
      //when loading handlechangetab
      show = true;
    } else if (
      !show &&
      visibleCondition?.toLowerCase()?.includes("defaulthide")
    ) {
      show = false;
    }

    //when editing handlechangetab
    if (JSON.stringify(editOrderDetails?.answers?.questionAnswer) !== "{}") {
      if (
        editOrderDetails?.answers?.questionAnswer[ID] &&
        (visibleCondition?.toLowerCase()?.includes("defaultshow") ||
          visibleCondition?.toLowerCase()?.includes("defaulthide"))
      ) {
        show = true;
      } else if (
        !editOrderDetails?.answers?.questionAnswer[ID] &&
        (visibleCondition?.toLowerCase()?.includes("defaultshow") ||
          visibleCondition?.toLowerCase()?.includes("defaulthide"))
      ) {
        show = false;

        if (
          showID?.includes(ID?.toString()) &&
          visibleCondition?.toLowerCase()?.includes("defaultshow")
        ) {
          show = true;
        }
        if (
          hideID?.includes(ID?.toString()) &&
          visibleCondition?.toLowerCase()?.includes("defaulthide")
        ) {
          show = true;
        }
      }
    }
  }
  //when handlechanging handlechangetab
  if (hideID && hideID?.length > 0 && hideID?.includes(ID?.toString())) {
    show = false;
  }
  if (
    showID &&
    showID?.length > 0 &&
    showID?.includes(ID?.toString()) &&
    visibleCondition?.toLowerCase()?.includes("defaulthide")
  ) {
    show = true;
  }
  return show;
};

export const rendergroupedQuestionOptions = (
  options,
  valuesParent,
  valuesOverall,
  i,
  questions,
  conditionChecker,
) =>
  options
    ? options.filter((o) => {
      if (o.visibleCondition) {
        const totalConditions = o.visibleCondition.split("<otherCondition>");
        const finalResult = conditionChecker(
          totalConditions,
          valuesParent,
          valuesOverall,
          i,
          questions,
        );
        if (finalResult) {
          return true;
        }
        return false;
      }
      return true;
    })
    : [];

export const exportRowToCSV = (rowData, subRowData, outstandingInvoices, t) => {
  const isEliteProgram =
    (Array.isArray(rowData) && rowData.some((x) => x.eliteProgram === "Yes")) ||
    (Array.isArray(subRowData) &&
      subRowData.some((x) => x.eliteProgream === "Yes"));

  const getEliteFee = (row) => {
    const diff =
      parseFloat(
        row?.invoiceTotal?.replaceAll("$", "")?.replaceAll(",", "") || 0,
      ) -
      parseFloat(
        row?.invoicetotalWithoutElite
          ?.replaceAll("$", "")
          ?.replaceAll(",", "") || 0,
      );

    return row?.eliteProgream === "No" || diff.toFixed(2) === "0.00"
      ? "N/A"
      : `$${diff.toFixed(2)}`;
  };
  const mappedData =
    outstandingInvoices === "outstandingInvoices"
      ? rowData?.map((row) => ({
        [t("Province")]: row?.province,
        [t("FileNumber")]: row?.fileNumber,
        [t("Premium")]: row?.premium,
        [t("Tax")]: row?.invoiceTax,
        [t("SubTotal")]: row?.invoiceSubtotal,
        ...(isEliteProgram && {
          [t("EliteFee")]: getEliteFee(row),
        }),
        [t("NetDue")]: row?.invoiceTotal,
        [t("BillingType")]: row?.billingType,
        [t("FirmName")]: row?.firmName,
        [t("Lawyer")]: row?.lawyerName,
        [t("OrderType")]: row?.dealType,
        [t("Reference")]: row?.referenceNumber,
        [t("InvoiceNo.")]: row?.invoiceID,
        [t("ClosingDate")]: row?.closingDate,
        [t("Clients")]: row?.clients,
        [t("PropertyAddress")]: parse(
          row?.propertyAddress?.replaceAll("<br>", "</br>"),
        ),
      }))
      : outstandingInvoices === "pastPayments"
        ? rowData?.map((row) => ({
          [t("Province")]: row?.province,
          [t("FileNumber")]: row?.fileNumber,
          [t("Premium")]: row?.premium,
          [t("Tax")]: row?.invoiceTax,
          [t("SubTotal")]: row?.invoiceSubtotal,
          ...(isEliteProgram && {
            [t("EliteFee")]:
              row?.eliteFee === "$0.00" ? "N/A" : row?.eliteFee,
          }),
          [t("NetDue")]: row?.netDue,
          [t("PaymentType")]: row?.paymentType,
          [t("ChequeNumber")]: row?.chequeNumber || "N/A",
          [t("ChequeDate")]: row?.chequeDate || "N/A",
          [t("CreditCardType")]:
            row?.creditCardType ||
            (row?.paymentMethod?.includes("Credit Card")
              ? (row?.paymentMethod?.match(/Credit Card (\w+)/) || [])[1]
              : "N/A"),
          [t("DatePaid")]: row?.datePaid,
          [t("FirmName")]: row?.firmName,
          [t("Lawyer")]: row?.lawyerName,
          [t("OrderType")]: row?.dealType || row?.orderType,
          [t("Reference")]: row?.referenceNumber,
          [t("InvoiceNo")]: row?.invoiceNo,
          [t("ClosingDate")]: row?.closingDate,
          [t("Clients")]: row?.clientName,
          [t("PropertyAddress")]: parse(
            row?.propAddress?.replaceAll("<br>", "</br>"),
          ),
        }))
        : subRowData?.map((row) => ({
          [t("Province")]: row?.province,
          [t("FileNumber")]: row?.fileNumber,
          [t("Premium")]: row?.premium || row?.invoiceTotal,
          [t("Tax")]: row?.invoiceTax,
          [t("SubTotal")]: row?.invoiceSubTotal,
          ...(isEliteProgram && {
            [t("EliteFee")]:
              row?.eliteProgream === "No"
                ? "N/A"
                : `$${(
                  parseFloat(
                    row?.invoiceTotal
                      ?.replaceAll("$", "")
                      ?.replaceAll(",", "") || 0,
                  ) -
                  parseFloat(
                    row?.invoicetotalWithoutElite
                      ?.replaceAll("$", "")
                      ?.replaceAll(",", "") || 0,
                  )
                ).toFixed(2)}`,
          }),
          [t("NetDue")]: row?.invoiceTotal,
          [t("PaymentType")]: rowData?.paymentMethod,
          [t("ChequeNumber")]: rowData?.chequeNumber || "N/A",
          [t("ChequeDate")]: rowData?.paymentDate,
          [t("CreditCardType")]: rowData?.paymentMethod?.includes(
            "Credit Card",
          )
            ? (rowData?.paymentMethod?.match(/Credit Card (\w+)/) || [])[1]
            : "N/A",
          [t("DatePaid")]: rowData?.paymentDate,
          [t("FirmName")]: rowData?.firmname,
          [t("Lawyer")]: row?.lawyerName,
          [t("OrderType")]: row?.dealType,
          [t("Reference")]: row?.internalRefernece,
          [t("InvoiceNo.")]: row?.invoiceID,
          [t("ClosingDate")]: row?.closingDate,
          [t("Clients")]: row?.clients,
          [t("PropertyAddress")]: parse(
            row?.propertyAddress?.replaceAll("<br>", "</br>"),
          ),
        }));

  const worksheet = XLSX.utils.json_to_sheet(mappedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

  const fileName = `Payment-${subRowData
    ? rowData.paymentDate
    : outstandingInvoices === "pastPayments"
      ? "Past Payments"
      : "Outstanding Invoices"
    }.xlsx`;

  XLSX.writeFile(workbook, fileName);
};

export const CheckCommercialQuoteOver25M = (price, values, userLogin) => {
  if (
    (values?.PublicdealType === "Commercial" ||
      values?.dealtype === "Commercial") &&
    (!userLogin ||
      userLogin?.loginName === null ||
      userLogin === undefined ||
      (userLogin && userLogin.loginName != null && !userLogin?.internalUser))
  ) {
    if (price > 25000000.0) {
      return true;
    }
  }
  return false;
};

export const CheckPurchaseTransForPropertyAggregate = (index, values) => {
  let isAtleastOnePurchaseproperty = false;
  for (let i = 0; i < index; i++) {
    if (values?.QuoteProperty[i]?.TransPurchase?.toLowerCase() === "yes") {
      isAtleastOnePurchaseproperty = true;
    }
  }
  return isAtleastOnePurchaseproperty;
};

export const GetBusinessHourAndPhoneDetails = (province, text, lang) => {
  if (["QC", "NB", "NL", "NS", "PE"]?.includes(province)) {
    if (lang == "en") {
      text = text?.replaceAll(
        "@businessHour",
        "Monday to Friday 9 am to 5 pm EST",
      );
    } else {
      text = text?.replaceAll(
        "@businessHour",
        "du lundi au vendredi, de 9h à 17h",
      );
    }
    text = text?.replaceAll("@businessPhone", "514-849-3113 or 1-877-849-3113");
  } else if (
    ["ON", "BC", "AB", "SK", "MB", "YT", "NT", "NU"]?.includes(province)
  ) {
    if (lang == "en") {
      text = text?.replaceAll(
        "@businessHour",
        "Monday to Friday 9 am to 8 pm EST",
      );
    } else {
      text = text?.replaceAll(
        "@businessHour",
        "du lundi au vendredi, de 9h à 20h",
      );
    }
    text = text?.replaceAll("@businessPhone", "289-562-5216 or 1-888-868-4853");
  }
  return text;
};

export const formatDigits = (digits) => {
  const raw = digits?.replace(/\D/g, "").slice(0, 8); // Remove non-digit characters
  const len = raw?.length;

  if (len === 8) return raw?.replace(/(\d{2})(\d{3})(\d{3})/, "$1 $2 $3");
  if (len === 7) return raw?.replace(/(\d{1})(\d{3})(\d{3})/, "$1 $2 $3");
  if (len === 6) return raw?.replace(/(\d{3})(\d{3})/, "$1 $2");
  if (len === 5) return raw?.replace(/(\d{2})(\d{3})/, "$1 $2");
  if (len === 4) return raw?.replace(/(\d{1})(\d{3})/, "$1 $2");
  if (len <= 3) return raw;
  return "";
};

export const setDefaultAnswersForDynamicQuestions = (
  standardQuestionName,
  editOrderDetails,
  i,
  formName,
  ID,
  programcodeDetails,
  { setValue, trigger },
) => {
  if (standardQuestionName === "EncompassHomeEmail") {
    //US576515 point 7
    const editAnswerValue = editOrderDetails?.answers?.properties[i]?.questionAnswer?.filter(x => x.questionID === ID.toString())[0]?.answerValue || "";
    const PropertyEmail =
      (editOrderDetails?.propertyList[i]?.personalBorrowers[0]?.email !== "" &&
        editOrderDetails?.propertyList[i]?.personalBorrowers[0]?.email !== null &&
        editOrderDetails?.propertyList[i]?.personalBorrowers[0]?.email !==
        undefined
        ? editOrderDetails?.propertyList[i]?.personalBorrowers[0]?.email
        : editAnswerValue);
    setValue(`${formName}.QuestionID_${ID}`, PropertyEmail);
  }

  if (
    ["NameOfTheLenderOriginating", "Name_Of_The_Lender_Originating"]?.includes(
      standardQuestionName,
    ) &&
    programcodeDetails?.programCode?.toLowerCase() !== "mcap"
  ) {
    const questionIndex = parseInt(formName?.split(".")[1]);
    const lenderCOName =
      editOrderDetails?.insuredMortgageList[questionIndex]?.fullLender
        ?.split(/c\/o|a\/s/i)[1]
        ?.trim() || "";
    lenderCOName !== "" &&
      setValue(`${formName}.QuestionID_${ID}`, lenderCOName);
  }
};

export const setIntialValueForDynamicQuestions = (
  Options,
  standardQuestionName,
  ID,
  formName,
  values,
  defautlAnswerForProgramCode,
  programCodeDetails,
  editOrderDetails,
  i,
  { setValue, trigger },
) => {
  const optionSelected = Options.find(({ isSelected }) => isSelected);
  if (
    optionSelected &&
    (values["QuestionID_" + ID] === undefined ||
      values["QuestionID_" + ID] === null)
  ) {
    setValue(
      `${formName}.QuestionID_${ID}`,
      optionSelected?.questionAnswerValue,
    );
    trigger(`${formName}.QuestionID_${ID}`);
  }
  //initially set as empty
  else if (
    !optionSelected &&
    values &&
    (values["QuestionID_" + ID] === undefined ||
      values["QuestionID_" + ID] === null)
  ) {
    setValue(`${formName}.QuestionID_${ID}`, "");
  }
  //initially set as empty
  //added for default answer program code starts
  if (
    defautlAnswerForProgramCode !== null &&
    defautlAnswerForProgramCode !== "" &&
    programCodeDetails !== null &&
    values &&
    (values["QuestionID_" + ID] === undefined ||
      values["QuestionID_" + ID] === null ||
      values["QuestionID_" + ID] === "")
  ) {
    setValue(`${formName}.QuestionID_${ID}`, defautlAnswerForProgramCode);
    trigger(`${formName}.QuestionID_${ID}`);
  }

  //setting default answers for question based on standardquestionname
  setDefaultAnswersForDynamicQuestions(
    standardQuestionName,
    editOrderDetails,
    i,
    formName,
    ID,
    programCodeDetails,
    { setValue, trigger },
  );
};

export const isSPETPEEncroachmentQuestionHidden = (
  standardQuestionName,
  editOrderDetails,
  dealType,
  formName,
  questions,
  values,
) => {
  if (
    HarbourMortgageStandardQuestionName?.includes(standardQuestionName) &&
    dealType === 1
  ) {
    const lenderIndex = formName?.split(".")[1];
    const typeOfMortgage =
      editOrderDetails?.insuredMortgageList[parseInt(lenderIndex)]
        ?.typeOfMortgage;
    const lenderName =
      editOrderDetails?.insuredMortgageList[parseInt(lenderIndex)]
        ?.fullLender || "";
    let lenderOriginatingQuestionID = questions?.filter(
      (x) => x.standardQuestionName === "Name_Of_The_Lender_Originating",
    )[0]?.id;
    const computerShareChildQuestionAnswer = values[
      `QuestionID_${lenderOriginatingQuestionID}`
    ]
      ?.toLowerCase()
      ?.replace(/[^a-z]/g, "");
    const normalizedLenderName = lenderName
      ?.toLowerCase()
      ?.replace(/[^a-z]/g, "");
    const isHarbourLender = normalizedLenderName?.includes(
      "harbourmortgagecorp",
    );
    const isComputershareLender =
      normalizedLenderName?.includes("computersharetrustcompanyofcanada") &&
      (computerShareChildQuestionAnswer?.includes("harbourmortgagecorp") ||
        (computerShareChildQuestionAnswer?.includes("harbour") &&
          computerShareChildQuestionAnswer?.includes("firstnational")));

    if (
      typeOfMortgage?.toLowerCase() === "1" &&
      (isHarbourLender || isComputershareLender)
    ) {
      return true;
    }
  }
  return false;
};
export function getSameDeedBehavior(standardQuestionName) {
  if (!standardQuestionName) return null;

  const groupKey = Object.keys(SAME_DEED_GROUPS).find((key) =>
    SAME_DEED_GROUPS[key].includes(standardQuestionName),
  );

  if (!groupKey) return null;

  return {
    groupKey,
    ...SAME_DEED_RULES[groupKey], // => { behavior: "..." }
  };
}

export function MoveUP() {
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
}

export const getSourcePropertyIndex = ({
  questionId,
  questionDetailsForUnderwriting,
  getValues,
}) => {
  const total = questionDetailsForUnderwriting.propertyList.length;

  for (let i = 0; i < total; i++) {
    const fieldPath = `UnderWritingProperties.${i}.QuestionID_${questionId}`;
    const value = getValues(fieldPath);

    // Question is rendered if the field exists in RHF
    if (value !== undefined) {
      return i;
    }
  }

  return null;
};
export const GetDocumentTypeForMultiUpload = (
  standardQuestionName,
  questions,
  values,
) => {
  let documentType = null;
  if (
    ["MultiFactoReportExpress", "Multi_Factor_Report_Express"]?.includes(
      standardQuestionName,
    )
  ) {
    documentType = "Multi factor ID verification report";
  } else if (
    ["PhotoIDExpress", "PhotoID_Express"]?.includes(standardQuestionName)
  ) {
    let question = questions?.filter(
      (x) =>
        (x.standardQuestionName === "IDTypeExpress" ||
          x.standardQuestionName === "ID_Type_Express") &&
        x.parentQuestionValue === "0",
    )[0];
    documentType = question?.options?.filter(
      (x) => x.questionAnswerValue === values["QuestionID_" + question?.id],
    )[0]?.questionAnswerLabel;
  } else if (
    [
      "MandatoryRegulatoryCorpUploadExpress",
      "Non_Corporate_Entity_Corp_Upload_Express",
    ]?.includes(standardQuestionName)
  ) {
    documentType = "Corporate Profile";
  }
  return documentType;
};

export const GetTextTypeForEncompassChildQuestion = (
  standardQuesitonName,
  formName,
  editOrderDetails,
) => {
  let textType = "";
  if (MaskedStandardQuestionName?.includes(standardQuesitonName)) {
    const formNameSplit = formName?.split(".");
    const questionID = formNameSplit[2]?.split("_")[1];
    const answerValue = editOrderDetails?.answers?.properties[
      parseInt(formNameSplit[1])
    ]?.questionAnswer?.filter((x) => x.questionID === questionID)[0]
      ?.answerValue;
    if (answerValue) {
      textType = "masked";
    }
  }
  return textType;
};

export function useClearHiddenFields(values, setValue, rules) {
  useEffect(() => {
    rules.forEach((rule) => {
      const emptyValue = "emptyValue" in rule ? rule.emptyValue : null;
      const rowCount = rule.rows ? rule.rows(values) || 0 : 1;

      for (let i = 0; i < rowCount; i++) {
        const path = rule.rows ? rule.path(i) : rule.path;
        const visible = rule.isVisible(values, i);

        if (!visible) {
          const current = getByPath(values, path);
          const isAlreadyEmpty =
            current === emptyValue ||
            current === undefined ||
            current === "" ||
            current === null;

          if (!isAlreadyEmpty) {
            setValue(path, emptyValue, {
              shouldValidate: false,
              shouldDirty: true,
            });
          }
        }
      }
    });
    // Re-run whenever the underlying data changes. Callers can pass a more
    // targeted slice of `values` in if JSON.stringify-ing the whole form
    // becomes a perf concern.
  }, [JSON.stringify(values)]);
}

function getByPath(obj, path) {
  return path
    .split(".")
    .reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
}

export const isQuoteLockedField = (fieldKey, fileDetailsInfo, editOrderDetails, index) => {
  const userLogin = getUserDetails();
  const hasQuoteNumber =
    fileDetailsInfo?.quoteNumber && Boolean(fileDetailsInfo.quoteNumber);
  const isExternalUser = userLogin?.internalUser === false;
  let hasValues = false;
  if (fieldKey === "thisTransIsPurchase") {
    hasValues = Boolean(editOrderDetails?.propertyList[index]?.isPurchase);
  } else if (fieldKey === "ownersPolicyReq") {
    hasValues = Boolean(editOrderDetails?.propertyList[index]?.isOwner);
  } else if (fieldKey === "existingOwnersPolicyReq") {
    hasValues = Boolean(editOrderDetails?.propertyList[index]?.isExistingOwner);
  } else if (fieldKey === "loanPolicy") {
    hasValues = Boolean(editOrderDetails?.isLoan);
  } else if (fieldKey === "Lender") {
    hasValues = Boolean(
      editOrderDetails?.insuredMortgageList[index]?.fullLender,
    );
  } else if (fieldKey === "MortgagePriority") {
    hasValues = Boolean(editOrderDetails?.insuredMortgageList[index]?.priority);
  } else if (fieldKey === "mortgageAmount") {
    hasValues = Boolean(editOrderDetails?.insuredMortgageList[index]?.amount);
  }
  return (
    hasQuoteNumber && isExternalUser && hasValues && QUOTE_DISABLED_FIELDS.includes(fieldKey)
  );
};

export const getRandomSearchText = (str) => {
  // const start = Math.floor(Math.random() * str.length);
  // const length = Math.floor(Math.random() * 4) + 2; // 2-5 chars
  return str.substring(0, 3).trim();
};

export const getOrderStatusTipDetails = (status, { t }) => {
  return (<div className="ml-3">
    {status.toLowerCase() === "not yet submitted" && (
      <>
        <div
          style={{ cursor: "pointer" }}
          className="flex h-full items-center justify-center w-full"
          data-tooltip-id="my-tooltip"
          data-tooltip-content={t(status)}
        >
          <svg width="20" height="20" fill="none">
            <path
              d="M4.167 10h11.667"
              stroke="#595959"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <ReactTooltip
          id="my-tooltip"
          style={{
            borderRadius: "2px",
            padding: "8px 12px",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
            display: "block",
            color: "black"
          }}
          className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
        />
      </>
    )
    }
    {
      status.toLowerCase() === "submitted for review" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <path
                d="M13.333 3.332H15a1.667 1.667 0 0 1 1.666 1.667v11.666A1.667 1.667 0 0 1 15 18.332H5a1.667 1.667 0 0 1-1.667-1.667V5A1.667 1.667 0 0 1 5 3.332h1.666"
                stroke="#595959"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.5 1.668h-5a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833h5c.46 0 .834-.373.834-.833V2.501a.833.833 0 0 0-.834-.833Z"
                stroke="#595959"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>

      )
    }
    {
      status.toLowerCase() ===
      "waiting for information" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <g
                clipPath="url(#clip0_4811_197264)"
                stroke="#595959"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667ZM8.333 12.5v-5M11.667 12.5v-5" />
              </g>
              <defs>
                <clipPath id="clip0_4811_197264">
                  <rect width="20" height="20" fill="#fff" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
    {
      status.toLowerCase() === "needs approval" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <g
                clipPath="url(#clip0_4811_197272)"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path
                  d="M10 18.335a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Z"
                  strokeWidth="1.5"
                />
                <path d="M10 6.668v3.333M10 13.332h.009" strokeWidth="2" />
              </g>
              <defs>
                <clipPath id="clip0_4811_197272">
                  <rect width="20" height="20" fill="#fff" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
    {
      status.toLowerCase() === "under review" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <g
                clipPath="url(#clip0_4811_197280)"
                stroke="#595959"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9.167 3.332H3.334a1.667 1.667 0 0 0-1.667 1.667v11.666a1.667 1.667 0 0 0 1.667 1.667H15a1.667 1.667 0 0 0 1.667-1.667v-5.833" />
                <path d="M15.417 2.084a1.768 1.768 0 0 1 2.5 2.5L10 12.501l-3.333.833.833-3.333 7.917-7.917Z" />
              </g>
              <defs>
                <clipPath id="clip0_4811_197280">
                  <rect width="20" height="20" fill="#fff" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
    {
      status.toLowerCase() === "review complete" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <path
                d="m7.5 9.165 2.5 2.5 8.333-8.333"
                stroke="#595959"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.5 10v5.833a1.666 1.666 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 15.833V4.167A1.667 1.667 0 0 1 4.167 2.5h9.166"
                stroke="#595959"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
    {
      status.toLowerCase() === "ctic ready for pickup" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <g
                clipPath="url(#clip0_4811_197294)"
                stroke="#09B505"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18.334 9.232v.766a8.334 8.334 0 1 1-4.942-7.616" />
                <path d="M18.333 3.332 10 11.674l-2.5-2.5" />
              </g>
              <defs>
                <clipPath id="clip0_4811_197294">
                  <rect width="20" height="20" fill="#fff" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
    {
      status.toLowerCase() === "ready for pickup" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <path
                d="M16.666 5 7.5 14.167 3.333 10"
                stroke="#09B505"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
    {
      status.toLowerCase() === "picked up" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <path
                d="M17.5 6.668v10.833h-15V6.668M19.166 2.5H.833v4.167h18.333V2.5ZM8.333 10h3.333"
                stroke="#27BD23"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
    {
      status.toLowerCase() === "cancellation pending" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <g
                clipPath="url(#clip0_4811_197315)"
                stroke="#E2211C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m12.5 7.5-5 5M7.5 7.5l5 5M18.334 9.232v.766a8.334 8.334 0 1 1-4.942-7.616" />
              </g>
              <defs>
                <clipPath id="clip0_4811_197315">
                  <rect width="20" height="20" fill="#fff" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
    {
      status.toLowerCase() === "cancelled" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <path
                d="M15 5 5 15M5 5l10 10"
                stroke="#E2211C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
    {
      status.toLowerCase() === "pending" && (
        <>
          <div
            style={{ cursor: "pointer" }}
            className="flex h-full items-center justify-center w-full"
            data-tooltip-id="my-tooltip"
            data-tooltip-content={t(status)}
          >
            <svg width="20" height="20" fill="none">
              <g
                stroke="#595959"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="10" cy="10" r="8.333" />
                <path d="M10 5.833v4.167l2.5 2.5" />
              </g>
            </svg>
          </div>
          <ReactTooltip
            id="my-tooltip"
            style={{
              borderRadius: "2px",
              padding: "8px 12px",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
              display: "block",
              color: "black"
            }}
            className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
          />
        </>
      )
    }
  </div>);
};

export const getOrderResultsTipDetails = (result, { t }) => {
  return (<div className="ml-3">
    {result?.toLowerCase() === "pending" && (
      <>
        <div
          style={{ cursor: "pointer" }}
          className="flex h-full items-center justify-center w-full"
          data-tooltip-id="my-tooltip"
          data-tooltip-content={t(result)}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="10"
              cy="10"
              r="8.333"
              stroke="#595959"
              strokeWidth="1.5"
            />
            <path
              d="M10 6.667V10L12.5 11.667"
              stroke="#595959"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <ReactTooltip
          id="my-tooltip"
          style={{
            borderRadius: "2px",
            padding: "8px 12px",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
            display: "block",
            color: "black"
          }}
          className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
        />
      </>
    )
    }
    {result?.toLowerCase() === "pass" && (
      <>
        <div
          style={{ cursor: "pointer" }}
          className="flex h-full items-center justify-center w-full"
          data-tooltip-id="my-tooltip"
          data-tooltip-content={t(result)}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.667 5L7.5 14.167L3.333 10"
              stroke="#595959"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <ReactTooltip
          id="my-tooltip"
          style={{
            borderRadius: "2px",
            padding: "8px 12px",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
            display: "block",
            color: "black"
          }}
          className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
        />
      </>
    )
    }
    {result?.toLowerCase() === "fail" && (
      <>
        <div
          style={{ cursor: "pointer" }}
          className="flex h-full items-center justify-center w-full"
          data-tooltip-id="my-tooltip"
          data-tooltip-content={t(result)}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="#595959"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <ReactTooltip
          id="my-tooltip"
          style={{
            borderRadius: "2px",
            padding: "8px 12px",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 14px",
            display: "block",
            color: "black"
          }}
          className="absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto"
        />
      </>
    )
    }

  </div>);
};